import { boolean, InferType, object, string } from "yup";

export type IFormularioPDVDataSystemSchema = InferType<
  typeof formPDVDataSystemSchema
>;

export const formPDVDataSystemSchema = object({
  date: string().required(),
  selecionarPeriodo: boolean().required(),
  inicio: string().nullable(),
  fim: string().nullable(),
  tipoDePesquisa: string().required()
});
